<template>
  <BaseModal overlay-class="other_modals" modal-content-class="submit_success">
    <div class="content">
      <BaseImage src="/static/images/other/device_icon.svg" alt="Different Devices Icon" />

      <h3 class="title">{{ $_translations.value.modal_success_verify_email_title }}</h3>

      <p class="games-to-price">
        <template
          v-for="(descriptionConfiguration, index) in descriptionConfigurationList"
          :key="index"
        >
          <span v-if="descriptionConfiguration.highlight">{{ descriptionConfiguration.text }}</span>
          <template v-else>{{ descriptionConfiguration.text }}</template>

          {{ ' ' }}
        </template>
      </p>

      <p>{{ $_translations.value.modal_success_verify_email_description_extra }}</p>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';

const { proxy } = getCurrentInstance();

const descriptionConfigurationList = computed(() => {
  const list = [{ text: proxy.$_translate('modal_success_verify_email_description_pt1'), highlight: false }];

  const totalGames = proxy.$_translate('modal_success_verify_email_description_pt2');
  const totalPoints = proxy.$_translate('modal_success_verify_email_description_pt5');

  if (totalGames) {
    list.push(
      { text: totalGames, highlight: true },
      { text: proxy.$_translate('modal_success_verify_email_description_pt3'), highlight: true },
    );
  }

  if (totalPoints) {
    if (totalGames) {
      list.push({ text: proxy.$_translate('modal_success_verify_email_description_pt4'), highlight: false });
    }

    list.push(
      { text: totalPoints, highlight: true },
      { text: proxy.$_translate('modal_success_verify_email_description_pt6'), highlight: true },
    );
  }

  return list;
});
</script>
